<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>

  <div>

    <vx-card v-if="showEmptyDataMessage">

      <vs-alert icon="warning" active="true" color="warning" class="my-5">
        <span>Acesso negado para adicionar registro.</span>
      </vs-alert>

    </vx-card>

    <vx-card :title="$t('SEARCH.searchParams')" v-if="arrayIsFilled" collapse-action @keyup.enter="applyFilters">

      <div class="vx-row mb-3" v-for="queryFieldRow in queryFields" :key="queryFieldRow.hash">

        <template v-for="field in queryFieldRow">

          <div class="vx-col w-full md:w-1/4">

            <template v-if="field.mask && field.type_id === 3">
              <label class="vs-input--label">{{ $displayLabel(field, 'title') }}</label>
              <div class="vx-input-group flex mb-0">
                <div class="vx-input-group-default flex-grow">
                  <div>
                    <div class="vs-component vs-con-input-label vs-input inputx vs-input-primary">
                      <div class="vs-con-input">
                        <the-mask :type="'text'" autocomplete="new-password" :name="field.name"
                          v-model="queryFieldsModel[field.hash]" :mask="['(##) ####-####', '(##) #####-####']"
                          class="vs-inputx vs-input--input normal hasValue need-style-placeholder disabled-field-class"
                          :maxlength="field.length || 524288" style="border: 1px solid rgba(0, 0, 0, 0.2);" />
                      </div>
                      <span></span>
                    </div>
                  </div>
                </div>
              </div>
            </template>

            <template v-else-if="field.mask && field.type_id !== 3">
              <label class="vs-input--label">{{ $displayLabel(field, 'title') }}</label>
              <div class="vx-input-group flex mb-0">
                <div class="vx-input-group-default flex-grow">
                  <div>
                    <div class="vs-component vs-con-input-label vs-input inputx vs-input-primary">
                      <div class="vs-con-input">
                        <the-mask :type="'text'" autocomplete="new-password" :name="field.name"
                          v-model="queryFieldsModel[field.hash]" :mask="field.mask"
                          class="vs-inputx vs-input--input normal hasValue need-style-placeholder disabled-field-class"
                          :maxlength="field.length || 524288" style="border: 1px solid rgba(0, 0, 0, 0.2);" />
                      </div>
                      <span></span>
                    </div>
                  </div>
                </div>
              </div>
            </template>

            <template v-else-if="booleanFields.includes(field.type_id)" class="con-s w-full mb-2">
              <label class="vs-input--label">{{ $displayLabel(field, 'title') }}</label>
              <ul>
                <li>
                  <vs-switch v-model="queryFieldsModel[field.hash]" class="mt-2" />
                </li>
              </ul>
            </template>

            <template v-else-if="textFields.includes(field.type_id)">
              <vs-input style="width: 100%!important;" v-if="textFields.includes(field.type_id)" :label="$displayLabel(field, 'title')"
                v-model="queryFieldsModel[field.hash]" />
            </template>

            <template v-else-if="dateFields.includes(field.type_id)">

              <template v-if="field.from">
                <label class="vs-input--label">{{ $displayLabel(field, 'title') }}: {{ $t('SEARCH.dateFrom') }}</label>
                <div :data-field-hash="field.hash" type="from">
                  <vx-input-group>
                    <template slot="prepend">
                      <div class="prepend-text bg-primary" style="height: 37px!important;">
                        <span :is="'calendar-icon'" size="1x"></span>
                      </div>
                    </template>

                    <datepicker class="mb-3" data-is-date="true" v-model="datesModel[field.hash]['from']"
                      @input="onDateChange($event, field.hash, 'from')"
                      style="width: 100%!important;display: inline-block;" placeholder="" :language="languages['ptBR']"
                      format="dd/MM/yyyy"></datepicker>
                  </vx-input-group>
                </div>
              </template>

              <template v-else-if="field.to">
                <label class="vs-input--label">{{ $displayLabel(field, 'title') }}: {{ $t('SEARCH.dateTo') }}</label>
                <div :data-field-hash="field.hash" type="to">
                  <vx-input-group>
                    <template slot="prepend">
                      <div class="prepend-text bg-primary" style="height: 37.5px!important;">
                        <span :is="'calendar-icon'" size="1x"></span>
                      </div>
                    </template>

                    <datepicker class="mb-3" data-is-date="true" v-model="datesModel[field.hash]['to']"
                      :disabledDates="disabledDatesModel[field.hash]" @input="onDateChange($event, field.hash, 'to')"
                      style="width: 100%!important;display: inline-block;" :language="languages['ptBR']" placeholder=""
                      format="dd/MM/yyyy">
                    </datepicker>
                  </vx-input-group>
                </div>
              </template>
            </template>

            <template v-else-if="datetimeFields.includes(field.type_id)">

              <template v-if="field.from">
                <label class="vs-input--label">{{ $displayLabel(field, 'title') }}: {{ $t('SEARCH.dateFrom') }}</label>
                <div>
                  <vx-input-group>
                    <template slot="prepend">
                      <div class="prepend-text bg-primary" style="height: 37px!important;">
                        <span :is="'calendar-icon'" size="1x"></span>
                      </div>
                    </template>

                    <flat-pickr v-model="datetimesModel[field.hash]['from']"
                      :config="{ enableTime: true, dateFormat: 'd/m/Y H:i:S', enableSeconds: true, time_24hr: true }"
                      @input="onDatetimeChange($event, field.hash, 'from')" placeholder="" class="w-full"
                      :name="'datetime-from' + field.hash" />
                  </vx-input-group>
                </div>

              </template>

              <template v-else-if="field.to">
                <label class="vs-input--label">{{ $displayLabel(field, 'title') }}: {{ $t('SEARCH.dateTo') }}</label>
                <div>
                  <vx-input-group>
                    <template slot="prepend">
                      <div class="prepend-text bg-primary" style="height: 37.5px!important;">
                        <span :is="'calendar-icon'" size="1x"></span>
                      </div>
                    </template>

                    <flat-pickr v-model="datetimesModel[field.hash]['to']"
                      :config="{ enableTime: true, dateFormat: 'd/m/Y H:i:S', enableSeconds: true, time_24hr: true, minDate: disabledDatetimesModel[field.hash].from }"
                      @input="onDatetimeChange($event, field.hash, 'to')" placeholder="" class="w-full"
                      :name="'datetime-to' + field.hash" />
                  </vx-input-group>
                </div>

              </template>
            </template>
            <template v-else-if="listFields.includes(field.type_id)">
              <label class="vs-input--label">{{ $displayLabel(field, 'title') }}</label>
              <v-select v-model="queryFieldsModel[field.hash]" :options="optionFieldModel[field.hash]"
                @input="applyFilters" label="label">
                <template v-slot:option="option">
                  <span>{{ $displayLabel(option, 'label') }}</span>
                </template>
                <template v-slot:selected-option="option">
                  <span>{{ option ? $displayLabel(option, 'label') : '' }}</span>
                </template>
              </v-select>
            </template>
          </div>

        </template>

      </div>


      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="mt-8 flex flex-wrap items-center justify-between">
            <div class="flex flex-wrap items-center">
              <template v-for="(item, index) of moduleActions">
                <vs-button v-if="item.button_type === 'list' && isActionVisibleForRole(item)" :key="index" class="mr-2 mt-2" color="primary"
                  type="filled" icon-pack="feather" :icon="transformIconName(item.icon)" @click="triggerButtonAction(item)">
                  {{ item.name }}
                </vs-button>
              </template>
            </div>
            <div class="flex flex-wrap items-center">
              <vs-button color="#848484" type="filled" class="ml-4 mt-2" @click="clearFilters" icon-pack="feather"
                icon="icon-trash">{{ $t('SEARCH.clearFilters') }}</vs-button>
              <vs-button class="ml-4 mt-2" color="primary" @click="applyFilters" icon-pack="feather"
                icon="icon-filter">{{ $t('SEARCH.applyFilters') }}</vs-button>
            </div>
          </div>
        </div>
      </div>

    </vx-card><br /><br /><br />

    <!-- <div class="vx-row p-4" style="float:right!important;" v-if="!showEmptyDataMessage">
      <div class="vx-col-12" style="float:right!important;">
        <vs-button color="primary" style="float:right!important;" type="filled" v-show="permissions.canCreate" icon-pack="feather" icon="icon-plus-circle" @click="$router.push('/modules/add/' + $route.params.moduleHash)">Adicionar</vs-button>
        <vs-button class="mr-2" color="primary" style="float:right!important;" v-show="permissions.canExport" type="filled" icon-pack="feather" icon="icon-download" @click="download">Exportar CSV</vs-button>
        <download-excel
            style="float:right!important;"
            class="mr-2"
            :data="json_data"
            :fields="json_fields"
            worksheet="My Worksheet"
            type="xlsx"
            name="filename"
          >
          <vs-button color="primary"   type="filled" icon-pack="feather" icon="icon-download">Exportar Excel</vs-button>
        </download-excel>
      </div>
    </div>
      <br><br><br> -->
    <div class="vx-card p-6" v-if="!showEmptyDataMessage" style="margin-top: -60px!important;">
      <div class="vx-row">
        <div class="vx-col-12">
        </div>
      </div>
      <vs-table :sst="true" multiple :description="true" v-model="selectedRows" @search="handleSearch"
        @change-page="handleChangePage" @sort="handleSort" search :noDataText="$t('SEARCH.noRecordsFound')"
        :data="moduleRows">

        <!-- <template slot="header">
            <h3>{{moduleInfo['moduleName']}}</h3>
        </template> -->

        <template slot="thead">
          <template v-for="fieldTitle in tableTitles">
            <vs-th :key="fieldTitle.name" :sort-key="fieldTitle.name">{{ $displayLabel(fieldTitle, 'title') }}</vs-th>
          </template>
          <vs-th sort-key="actions">{{ $t('SEARCH.actions') }}</vs-th>
        </template>

        <template slot-scope="{data}">
          <!-- {{ moduleRows }} -->
          <vs-tr :data="tr" :key="tr.__hash || indextr" v-for="(tr, indextr) in data">
            <template v-for="(field, key) in tr">
              <vs-td :key="key + Math.random().toString()" :data="field"
                v-if="key !== '__hash' && key !== '__index' && key !== '__can_edit' && field !== null && typeof field === 'string' && field.includes('%%')">
                <vx-tooltip color="primary" :text="field.replace('%%', '%')">
                  <vs-progress v-if="parseInt(field.replace('%%', '').replace(',', '.')) <= 33" :height="8"
                    :percent="parseInt(field.replace('%%', '').replace(',', '.'))" color="primary"></vs-progress>
                  <vs-progress
                    v-else-if="parseInt(field.replace('%%', '').replace(',', '.')) >= 33 && parseInt(field.replace('%%', '').replace(',', '.')) <= 66"
                    :height="8" :percent="parseInt(field.replace('%%', '').replace(',', '.'))"
                    color="primary"></vs-progress>
                  <vs-progress v-else :height="8" :percent="parseInt(field.replace('%%', '').replace(',', '.'))"
                    color="primary"></vs-progress>
                </vx-tooltip>
              </vs-td>
              <vs-td :key="key + Math.random().toString()" :data="field"
                v-else-if="field !== null && typeof field === 'object' && field.hasOwnProperty('color') && field.hasOwnProperty('value')">
                <vs-chip :color="field.color" class="product-order-status">{{ $displayLabel(field, 'value') }}</vs-chip>
              </vs-td>
              <vs-td :key="key + Math.random().toString()" :data="field"
                v-else-if="field !== null && typeof field === 'object' && field.hasOwnProperty('value')">
                {{ $displayLabel(field, 'value') }}
              </vs-td>
              <vs-td :key="key + Math.random().toString()" :data="field"
                v-else-if="key !== '__hash' && key !== '__index' && key !== '__can_edit'">
                {{ field }}
              </vs-td>
            </template>
            <vs-td>
              <feather-icon v-show="permissions.canView" icon="EyeIcon"
                svgClasses="h-5 w-5 mr-2 hover:text-warning cursor-pointer"
                @click="$router.push(`/modules/view/${$route.params.moduleHash}/${tr.__hash}`)" />
              <feather-icon v-show="permissions.canEdit && tr.__can_edit !== false" icon="Edit3Icon"
                svgClasses="h-5 w-5 mr-2 hover:text-primary cursor-pointer"
                @click="$router.push(`/modules/edit/${$route.params.moduleHash}/${tr.__hash}`)" />
              <feather-icon v-show="permissions.canDelete" icon="Trash2Icon"
                svgClasses="h-5 w-5 mr-2 hover:text-danger cursor-pointer"
                @click="confirmDeleteRecord(tr.__hash)" />
              <feather-icon v-show="permissions.canEdit && tr.__can_edit !== false" icon="ExternalLinkIcon"
                svgClasses="h-5 w-5 mr-2 hover:text-primary cursor-pointer"
                @click="openNewWindow($route.params.moduleHash, tr.__hash)" />
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <br>
      <vs-pagination :total="pagination.pages" v-model="paginationModel" v-if="pagination.pages > 0" :max="pagesToShow"
        goto></vs-pagination>
    </div>
  </div>
</template>

<script>
import StringMask from 'string-mask'
import downloadExcel from "vue-json-excel";
import { jsontoexcel } from "vue-table-to-excel";
import vSelect from 'vue-select';
import Datepicker from 'vuejs-datepicker';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import * as lang from 'vuejs-datepicker/src/locale';
import { CalendarIcon } from 'vue-feather-icons'
import { setApplicationLocalStorageItem, performFetch, transformIconName } from '../../../helpers'

export default {
  components: {
    downloadExcel,
    jsontoexcel,
    vSelect,
    flatPickr,
    Datepicker,
    CalendarIcon
  },
  data: () => ({
    //advanced filter
    disabledDatesModel: {},
    disabledDatetimesModel: {},
    datesModel: {},
    datetimesModel: {},
    languages: lang,
    textFields: [1, 3, 4, 5, 6, 7, 8, 9, 10, 11, 14, 15, 19],
    booleanFields: [23],
    numberFields: [2],
    moneyFields: [16, 18],
    dateFields: [12],
    datetimeFields: [13],
    listFields: [24, 25, 29, 30, 33],
    optionFieldModel: [],
    fieldTypes: {},

    dateOperators: ['EQUAL', 'NOT_EQUAL', 'GREATER_THAN', 'GREATER_THAN_OR_EQUAL', 'LESS_THAN', 'LESS_THAN_OR_EQUAL', 'BETWEEN', 'NOT_BETWEEN', 'IN', 'NOT_IN', 'NULL', 'NOT_NULL'],
    datetimeOperators: ['EQUAL', 'NOT_EQUAL', 'GREATER_THAN', 'GREATER_THAN_OR_EQUAL', 'LESS_THAN', 'LESS_THAN_OR_EQUAL', 'BETWEEN', 'NOT_BETWEEN', 'IN', 'NOT_IN', 'NULL', 'NOT_NULL'],
    timeOperators: ['EQUAL', 'NOT_EQUAL', 'GREATER_THAN', 'GREATER_THAN_OR_EQUAL', 'LESS_THAN', 'LESS_THAN_OR_EQUAL', 'BETWEEN', 'NOT_BETWEEN', 'IN', 'NOT_IN', 'NULL', 'NOT_NULL'],
    intOperators: ['EQUAL', 'NOT_EQUAL', 'GREATER_THAN', 'GREATER_THAN_OR_EQUAL', 'LESS_THAN', 'LESS_THAN_OR_EQUAL', 'IN', 'NOT_IN', 'NULL', 'NOT_NULL'],
    textOperators: ['EQUAL', 'NOT_EQUAL', 'IN', 'NOT_IN', 'NULL', 'NOT_NULL', 'LIKE'],
    decimalOperators: ['EQUAL', 'NOT_EQUAL', 'GREATER_THAN', 'GREATER_THAN_OR_EQUAL', 'LESS_THAN', 'LESS_THAN_OR_EQUAL', 'IN', 'NOT_IN', 'NULL', 'NOT_NULL'],
    booleanOperators: ['EQUAL', 'NOT_EQUAL'],
    listOperators: ['EQUAL', 'NOT_EQUAL', 'NULL', 'NOT_NULL', 'IN', 'NOT_IN'],
    relatedModuleOperators: ['EQUAL', 'NOT_EQUAL', 'NULL', 'NOT_NULL', 'IN', 'NOT_IN'],

    queryFields: [],
    queryFieldsModel: {},
    filterObject: [],
    moduleActions: [],


    //list
    getDataInterval: null,
    tableKey: 0,
    json_fields: {
      "Complete name": "name",
      City: "city",
      Telephone: "phone.mobile",
      "Telephone 2": {
        field: "phone.landline",
        callback: (value) => {
          return `Landline Phone - ${value}`;
        },
      },
    },
    json: {
      dataSource: [
        { name: "Tom", phone: "+86 01012", email: "000@gmail.com" },
        { name: "Jack", phone: "+86 01012", email: "000@gmail.com" },
        { name: "Alice", phone: "+86 01012", email: "000@gmail.com" }
      ],
      head: ["name", "phone", "email"],
      fileName: "download-teste"
    },

    maxItems: null,
    moduleInfo: {
      moduleName: '',
      moduleNameEn: ''
    },
    pagesToShow: 1,
    paginationModel: 1,
    pagination: {
      currentPage: 1,
      pages: 1,
      per_page: 10,
      total_records: 0
    },
    selected: [],
    log: [],
    fieldHashObject: {},
    tableIndex: 0,
    showEmptyDataMessage: false,
    moduleRows: [],
    fullModuleRows: [],
    tableTitles: [],
    selectedRows: [],
    rowHashToDelete: '',
    permissions: {
      canCreate: true,
      canEdit: true,
      canDelete: true,
      canView: true,
      canList: true,
      canExport: true
    },
    orderData: {
      field: null,
      type: null
    },
    sst: true,
    searchKey: null,
    arrayIsFilled: false,
    language: {
      rtl: false,
      yearSuffix: "",
      ymd: false,
      _days: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
      _language: "Brazilian",
      _months: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
      _monthsAbbr: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez']
    }
  }),
  watch: {
    async paginationModel(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.pagination['currentPage'] = newValue
        this.applyFilters()
        // this.$vs.loading({type: 'default'})
        // this.pagination.currentPage = newValue
        // await this.listModuleRows(this.maxItems, newValue)
        // this.$vs.loading.close()
      }
    },
    async '$route.params.moduleHash'() {
      this.$vs.loading({ type: 'default' })
      this.moduleInfo.moduleName = ''
      this.moduleInfo.moduleNameEn = ''
      this.maxItems = null
      this.pagination = {}
      this.selected = []
      this.log = []
      this.tableIndex = 0
      this.showEmptyDataMessage = false
      this.moduleRows = []
      this.fullModuleRows = []
      this.tableTitles = []
      this.selectedRows = []
      this.rowHashToDelete = ''
      this.orderData.field = null
      this.orderData.type = null

      this.pagination['currentPage'] = 1
      this.pagination['pages'] = 1
      this.pagesToShow = 1
      this.disabledDatesModel = {}
      this.disabledDatetimesModel = {}
      this.datesModel = {}
      this.datetimesModel = {}
      this.queryFields = []
      this.queryFieldsModel = {}
      this.filterObject = []
      this.moduleActions = []
      await this.getSearchFields()
      await this.getModuleParameters()
      await this.getModuleActions()
      this.moduleRows = []
      this.paginationModel = 1
      this.$vs.loading.close()
    },
    async '$route.params.listHash'() {
      this.$vs.loading({ type: 'default' })
      this.moduleInfo.moduleName = ''
      this.moduleInfo.moduleNameEn = ''
      this.maxItems = null
      this.pagination = {}
      this.selected = []
      this.log = []
      this.tableIndex = 0
      this.showEmptyDataMessage = false
      this.moduleRows = []
      this.fullModuleRows = []
      this.tableTitles = []
      this.selectedRows = []
      this.rowHashToDelete = ''
      this.orderData.field = null
      this.orderData.type = null

      this.pagination['currentPage'] = 1
      this.pagination['pages'] = 1
      this.pagesToShow = 1
      this.moduleActions = []
      await this.getModuleParameters()
      await this.getModuleActions()
      await this.listModuleRows(this.maxItems, 1)
      this.$vs.loading.close()
      this.paginationModel = 1
    },
    selectedRows(value) {
      console.log(value)
    }
  },
  methods: {
    transformIconName,
    isActionVisibleForRole(action) {
      if (!action.roles || action.roles.length === 0) return true
      const role = this.$store.state.auth.role
      const roleHash = role && (role.identification || role.hash)
      if (!roleHash) return true
      return action.roles.includes(roleHash)
    },
    async getModuleActions() {
      await performFetch(this.$store.state.auth.api_url, {
        command: 'module_action__list',
        parameters: {
          application_token: this.$store.state.auth.app_token,
          session_token: this.$store.state.auth.token,
          module_hash: this.$route.params.moduleHash
        }
      })
        .then(async (response) => {
            if (response.status === 200) {
              response.json().then(async (response) => {

                this.moduleActions = response.actions

              })
          } else if (response.status == 401) {
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          } else {
            //this.$vs.loading.close()
          }
        })
        .catch((e) => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Operação não realizada!',
            text: e.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
          throw new Error(e.message)
        })
    },
    buildFilterFromForm() {
      let filter = []

      for (const fieldModel of Object.entries(this.queryFieldsModel)) {
        const fieldHash = fieldModel[0]
        const fieldValue = fieldModel[1]

        if (fieldHash in this.optionFieldModel) {
          if (fieldValue !== null) {
            filter.push({
              field_hash: fieldHash,
              operator_type: 'EQUAL',
              value: fieldValue.value
            })
          }
        } else {
          if (fieldValue !== null && fieldValue !== '') {
            if (typeof fieldValue === 'boolean') {
              filter.push({
                field_hash: fieldHash,
                operator_type: 'EQUAL',
                value: fieldValue
              })
            } else {
              filter.push({
                field_hash: fieldHash,
                operator_type: 'LIKE',
                value: fieldValue
              })
            }
          }
        }
      }

      for (const fieldModel of Object.entries(this.datesModel)) {
        const fieldHash = fieldModel[0]
        const fieldValue = fieldModel[1]

        if (fieldValue.to !== null) {
          let dateStr = fieldValue.to.toLocaleString('pt-BR').split(' ')[0]
          dateStr = `${dateStr.split('/')[2]}-${dateStr.split('/')[1]}-${dateStr.split('/')[0]}`.replace(',', '')
          filter.push({
            field_hash: fieldHash,
            operator_type: 'LESS_THAN_OR_EQUAL',
            value: dateStr
          })
        }
        if (fieldValue.from !== null) {
          let dateStr = fieldValue.from.toLocaleString('pt-BR').split(' ')[0]
          dateStr = `${dateStr.split('/')[2]}-${dateStr.split('/')[1]}-${dateStr.split('/')[0]}`.replace(',', '')
          filter.push({
            field_hash: fieldHash,
            operator_type: 'GREATER_THAN_OR_EQUAL',
            value: dateStr
          })
        }
      }

      for (const fieldModel of Object.entries(this.datetimesModel)) {
        const fieldHash = fieldModel[0]
        const fieldValue = fieldModel[1]

        if (fieldValue.to !== null) {
          let dateStr = fieldValue.to.toLocaleString('pt-BR')
          dateStr = `${dateStr.split(' ')[0].split('/')[2]}-${dateStr.split(' ')[0].split('/')[1]}-${dateStr.split(' ')[0].split('/')[0]} ${dateStr.split(' ')[1]}`
          filter.push({
            field_hash: fieldHash,
            operator_type: 'LESS_THAN_OR_EQUAL',
            value: dateStr
          })
        }
        if (fieldValue.from !== null) {
          let dateStr = fieldValue.from.toLocaleString('pt-BR')
          dateStr = `${dateStr.split(' ')[0].split('/')[2]}-${dateStr.split(' ')[0].split('/')[1]}-${dateStr.split(' ')[0].split('/')[0]} ${dateStr.split(' ')[1]}`
          filter.push({
            field_hash: fieldHash,
            operator_type: 'GREATER_THAN_OR_EQUAL',
            value: dateStr
          })
        }
      }

      return filter.length > 0 ? filter : null
    },
    async triggerButtonAction(buttonData) {

      this.$vs.loading({ type: 'default' })
      const user = this.$store.state.auth.user
      const userObject = typeof user === 'string' ? JSON.parse(user) : user
      const userHash = userObject && (userObject.hash || userObject.user_hash)

      const triggerData = {
        module_hash: this.$route.params.moduleHash,
        list_hash: this.$route.params.listHash ? this.$route.params.listHash : null,
        type: 'list'
      }

      const filter = this.buildFilterFromForm()
      if (filter !== null) {
        triggerData.filter = filter
      }

      await performFetch(`${this.$store.state.auth.api_url}/trigger-button-action`, {
        parameters: {
          application_token: this.$store.state.auth.app_token,
          session_token: this.$store.state.auth.token,
          user_hash: userHash,
          button_data: buttonData,
          trigger_data: triggerData,
        }
      })
        .then(async (response) => {

          if (!response.ok) {
            this.$vs.notify({
              title: 'Erro',
              text: 'Erro ao executar a função',
              iconPack: 'feather',
              icon: 'icon-bell',
              color: 'danger'
            })

            this.$vs.loading.close()

            return
          }

          if (buttonData.wait_response) {
            if (buttonData.response_type === 'notification') {

              const res = await response.json()

              if (res.hasOwnProperty('color') && res.hasOwnProperty('title') && res.hasOwnProperty('message')) {
                this.$vs.notify({
                  title: res.title,
                  text: res.message,
                  iconPack: 'feather',
                  icon: 'icon-bell',
                  color: res.color
                })
              }
            } else {

              const blob = await response.blob();

              const contentDisposition = response.headers.get('Content-Disposition');
              let filename = 'download';  // Nome padrão, caso o cabeçalho não esteja presente
              if (contentDisposition) {
                const filenameMatch = contentDisposition.match(/filename="(.+)"/);
                if (filenameMatch.length > 1) {
                  filename = filenameMatch[1];
                }
              }

              const mimeType = response.headers.get('Content-Type');

              // Cria um link temporário para forçar o download
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.href = url;

              // Define o nome do arquivo para download (opcional)
              a.download = filename;

              // Adiciona o link ao DOM e simula o clique para iniciar o download
              document.body.appendChild(a);
              a.click();

              // Remove o link temporário após o download
              document.body.removeChild(a);

              // Revoga o objeto URL criado para liberar memória
              window.URL.revokeObjectURL(url);

            }
          }

          this.$vs.loading.close()

        })
        .catch((e) => {

          throw new Error(e.message)
        })
    },
    onDateChange(date, fieldHash, type) {
      if (date !== null) {
        let dateStr = date.toLocaleString('pt-BR').split(' ')[0]
        dateStr = `${dateStr.split('/')[2]}-${dateStr.split('/')[1]}-${dateStr.split('/')[0]}`

        if (type === 'from') {
          this.disabledDatesModel[fieldHash].to = new Date(dateStr + ' GMT-0300')
          this.datesModel[fieldHash]['to'] = null
        }

      }
    },
    onDatetimeChange(date, fieldHash, type) {
      if (date !== null) {
        let dateStr = date.toLocaleString('pt-BR')
        dateStr = `${dateStr.split(' ')[0].split('/')[2]}-${dateStr.split(' ')[0].split('/')[1]}-${dateStr.split(' ')[0].split('/')[0]} ${dateStr.split(' ')[1]}`

        if (type === 'from') {
          this.disabledDatetimesModel[fieldHash].from = new Date(dateStr + ' GMT-0300')
          this.datetimesModel[fieldHash]['to'] = null
        }

      }
    },
    openNewWindow(moduleHash, rowHash) {
      const newWindowRoute = this.$router.resolve('/modules/edit/' + moduleHash + '/' + rowHash)
      window.open(newWindowRoute.href, '_blank')
    },
    async getSearchFields() {
      // await fetch(`${this.$store.state.auth.api_url}`, {
      //   method: 'POST', headers: {"Content-Type": "application/json"},
      //   body: JSON.stringify({
      //     command: 'get_application_module_search_fields',
      //     parameters: {
      //       application_token: this.$store.state.auth.app_token,
      //       session_token: this.$store.state.auth.token,
      //       module_token: this.$route.params.moduleHash
      //     }
      //   })
      // })
      await performFetch(this.$store.state.auth.api_url, {
        command: 'get_application_module_search_fields',
        parameters: {
          application_token: this.$store.state.auth.app_token,
          session_token: this.$store.state.auth.token,
          module_token: this.$route.params.moduleHash
        }
      })
        .then((response) => {
          if (response.status === 200) {
            response.json().then((responseData) => {

              let currentRowKey = 0
              let currentRowLength = 0

              const DATEFIELD = 12
              const DATETIMEFIELD = 13
              const LISTFIELD = 24
              const RELATEDMODULEFIELD = 25
              const STATUSFIELD = 29
              const RELATEDMODULEMULTIPLEFIELD = 33

              const fields = responseData.fields

              fields.sort((a, b) => {
                if (a.index < b.index) { return -1; }
                if (a.index > b.index) { return 1; }
                return 0;
              })

              for (const field of responseData.fields) {

                this.$set(this.queryFieldsModel, field.hash, null)

                this.$set(this.fieldTypes, field.hash, field.type_id)

                switch (field.type_id) {
                  case DATEFIELD:
                    this.$set(this.disabledDatesModel, field.hash, { from: null, to: null })
                    this.$set(this.datesModel, field.hash, { from: null, to: null })
                    break

                  case DATETIMEFIELD:
                    this.$set(this.disabledDatetimesModel, field.hash, { from: null, to: null })
                    this.$set(this.datetimesModel, field.hash, { from: null, to: null })
                    break

                  case LISTFIELD:
                  case RELATEDMODULEFIELD:
                  case STATUSFIELD:
                  case RELATEDMODULEMULTIPLEFIELD:

                    this.$set(this.optionFieldModel, field.hash, [])

                    for (const option of field.options) {
                      this.optionFieldModel[field.hash].push({
                        label: option.label,
                        label_en: option.label_en,
                        value: option.value
                      })
                    }

                    break

                  default:
                    break
                }

                if (currentRowLength === 0) {
                  this.queryFields[currentRowKey] = []

                  if (field.type_id === DATEFIELD || field.type_id === DATETIMEFIELD) {
                    const endField = JSON.parse(JSON.stringify(field))
                    field.from = true
                    field.to = false
                    endField.from = false
                    endField.to = true
                    this.queryFields[currentRowKey].push(field)
                    currentRowLength++

                    if (currentRowLength === 4) {
                      currentRowKey++
                      currentRowLength = 0
                      this.queryFields[currentRowKey] = []
                      this.queryFields[currentRowKey].push(endField)
                      currentRowLength++
                    } else {
                      this.queryFields[currentRowKey].push(endField)
                      currentRowLength++
                    }
                  } else {
                    this.queryFields[currentRowKey].push(field)
                    currentRowLength++
                  }
                } else if (currentRowLength === 4) {
                  currentRowKey++
                  currentRowLength = 0
                  this.queryFields[currentRowKey] = []

                  if (field.type_id === DATEFIELD || field.type_id === DATETIMEFIELD) {
                    const endField = JSON.parse(JSON.stringify(field))
                    field.from = true
                    field.to = false
                    endField.from = false
                    endField.to = true
                    this.queryFields[currentRowKey].push(field)
                    this.queryFields[currentRowKey].push(endField)
                    currentRowLength += 2
                  } else {
                    this.queryFields[currentRowKey].push(field)
                    currentRowLength++
                  }
                } else {

                  if (field.type_id === DATEFIELD || field.type_id === DATETIMEFIELD) {
                    const endField = JSON.parse(JSON.stringify(field))
                    field.from = true
                    field.to = false
                    endField.from = false
                    endField.to = true
                    this.queryFields[currentRowKey].push(field)
                    currentRowLength++

                    if (currentRowLength === 4) {
                      currentRowKey++
                      currentRowLength = 0
                      this.queryFields[currentRowKey] = []
                      this.queryFields[currentRowKey].push(endField)
                      currentRowLength++
                    } else {
                      this.queryFields[currentRowKey].push(endField)
                      currentRowLength++
                    }
                  } else {
                    this.queryFields[currentRowKey].push(field)
                    currentRowLength++
                  }
                }
              }

              this.arrayIsFilled = true
            })
              .catch(e => {
                this.$vs.loading.close()
                this.$vs.notify({
                  title: 'Atenção!',
                  text: e.message,
                  iconPack: 'feather',
                  icon: 'icon-alert-circle',
                  color: 'danger'
                })
                throw new Error(e.message)
              })
          } else if (response.status === 400) {
            this.$router.push(`/modules/view/${this.$route.params.moduleHash}`)
          } else if (response.status === 403) {
            this.$vs.loading.close()
            this.showEmptyDataMessage = true
          } else if (response.status === 401) {
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          } else {
            this.$vs.notify({
              title: 'Operação não realizada!',
              text: 'Ocorreu um erro ao listar os registros do módulo',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
          }
        })
        .catch((e) => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Atenção!',
            text: e.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
          throw new Error(e.message)
        })
    },
    async fetchData(page) {
      return new Promise(async (resolve, reject) => {
        const parametersObject = {
          application_token: this.$store.state.auth.app_token,
          session_token: this.$store.state.auth.token,
          module_token: this.$route.params.moduleHash,
          list_hash: this.$route.params.listHash,
          per_page: 1000,
          page: page,
          give_options: false
        }

        // await fetch(`${this.$store.state.auth.api_url}`, {
        //   method: 'POST', headers: {"Content-Type": "application/json"},
        //   body: JSON.stringify({
        //     command: 'list_module_rows',
        //     parameters: parametersObject
        //   })
        // })
        await performFetch(this.$store.state.auth.api_url, {
          command: 'list_module_rows',
          parameters: parametersObject
        })
          .then((response) => {
            if (response.status === 200) {
              response.json().then((responseData) => {
                resolve(responseData)
              })
                .catch(e => {
                  this.$vs.loading.close()
                  this.$vs.notify({
                    title: 'Atenção!',
                    text: e.message,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                  })
                  throw new Error(e.message)
                })
            } else if (response.status === 400) {
              this.$router.push(`/modules/view/${this.$route.params.moduleHash}`)
            } else if (response.status === 403) {
              this.$vs.loading.close()
              this.showEmptyDataMessage = true
            } else if (response.status === 401) {
              setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
              this.$store.dispatch('auth/signOut')
            } else {
              this.$vs.notify({
                title: 'Operação não realizada!',
                text: 'Ocorreu um erro ao listar os registros do módulo',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
              })
            }
          })
          .catch((e) => {
            this.$vs.loading.close()
            this.$vs.notify({
              title: 'Atenção!',
              text: e.message,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
            throw new Error(e.message)
          })
      })
    },
    prepareDataToCSV(responseData) {
      let moduleRows = []

      if (responseData.payload.length > 0) {
        responseData.payload.forEach((item, key) => {

          const formattedItems = []

          if (!(item.items && Object.keys(item.items).length === 0 && item.items.constructor === Object)) {
            Object.entries(item.items).forEach((itemObject) => {

              const objectKey = itemObject[0]
              let objectValue = itemObject[1]

              if (typeof objectValue === 'object' && objectValue !== null) {

                if (objectValue.secret === true) {
                  if (this.tableTitles.find(x => x.name === objectValue.name) === undefined) {
                    this.tableTitles.push({
                      title: objectValue.title,
                      title_en: objectValue.title_en,
                      name: objectValue.name
                    })
                  }

                  objectValue = '*****'
                } else {
                  if (this.tableTitles.find(x => x.name === objectValue.name) === undefined) {
                    this.tableTitles.push({
                      title: objectValue.title,
                      title_en: objectValue.title_en,
                      name: objectValue.name
                    })
                  }

                  if (objectValue.type_id === 35) {
                    if (Array.isArray(objectValue.payload)) {
                      let formattedArray = [];
                      let index = 0;
                      for (const date of objectValue.payload) {
                        if (index === 3) {
                          break;
                        }
                        const year = date.split('-')[0]
                        const month = date.split('-')[1]
                        const day = date.split('-')[2]
                        formattedArray.push(`${day}/${month}/${year}`)
                        index += 1;
                      }
                      objectValue = formattedArray.join(", ") + `${objectValue.payload.length > 3 ? "..." : ""}`
                    } else {
                      objectValue = null;
                    }
                  } else if (objectValue.type_id === 16 || objectValue.type_id === 18 || objectValue.type_id === 20) {

                    const type_id = objectValue.type_id
                    const showProgressBar = objectValue.show_progress_bar

                    let config = null

                    if (objectValue.type_id === 16 || objectValue.type_id === 20) {
                      config = { minimumFractionDigits: objectValue.decimals, maximumFractionDigits: objectValue.decimals }
                    } else {
                      config = { style: 'currency', currency: 'BRL', minimumFractionDigits: objectValue.decimals, maximumFractionDigits: objectValue.decimals }
                    }

                    const value = parseFloat(objectValue.payload)

                    if (!isNaN(value)) {
                      objectValue = parseFloat(objectValue.payload).toLocaleString('pt-BR', config)

                      if (type_id === 16) {
                        if (showProgressBar) {
                          objectValue = objectValue + '%%'
                        } else {
                          objectValue = objectValue + '%'
                        }
                      }
                    } else {
                      objectValue = null
                    }

                  } else if (objectValue.type_id === 19) {

                    if (objectValue.payload && objectValue.payload.length > 50) {
                      objectValue = objectValue.payload.substr(0, 50) + '...'
                    } else {
                      objectValue = objectValue.payload
                    }

                  } else if (objectValue.mask) {
                    const formatter = new StringMask(objectValue.mask)
                    const result = formatter.apply(objectValue.payload)

                    objectValue = result
                  } else {
                    objectValue = objectValue.payload
                  }

                  const isDateTime = this.checkIfStringIsDateTime(objectValue)

                  if (isDateTime) {

                    const date = objectValue.split(' ')[0].trim()
                    const time = objectValue.split(' ')[1].trim()

                    objectValue = `${date.split('-')[2]}/${date.split('-')[1]}/${date.split('-')[0]} ${time}`

                  }


                  const isDate = this.checkIfStringIsDate(objectValue)

                  if (isDate) {

                    objectValue = `${objectValue.split('-')[2]}/${objectValue.split('-')[1]}/${objectValue.split('-')[0]}`
                  }
                }

                itemObject[1] = objectValue
              }

              const fieldObject = {
                key: itemObject[0],
                value: itemObject[1]
              }

              formattedItems.push(fieldObject)
            })

            formattedItems.push({ key: '__hash', value: item.identification })
            formattedItems.push({ key: '__can_edit', value: item.can_edit !== undefined ? item.can_edit : true })

            const moduleRow = {}

            formattedItems.forEach((item) => {
              moduleRow[item['key']] = item['value']
            })

            moduleRows[key] = moduleRow
          }
        })

        if (responseData.payload.length < responseData.detail.lines_per_page) {

          moduleRows = this.moduleRows.filter(el => el != null)
        }
      }

      return moduleRows
    },
    async fetchAllDataToDownload() {
      let page = 1
      return new Promise(async (resolve, reject) => {

        let moduleRows = []

        await this.fetchData(page).then(async responseData => {
          moduleRows = this.prepareDataToCSV(responseData)
          if (responseData.pagination.pages > 1) {
            for (let i = responseData.pagination.current_page; i <= responseData.pagination.pages; i++) {
              await this.fetchData(i).then(responseData => {
                moduleRows += this.prepareDataToCSV(responseData)
              }).catch(() => { })
            }
          }

          resolve(moduleRows)
        })
          .catch(e => {
            console.log(e)
          })
      })
    },
    async download() {

      let moduleRows = []

      // const moduleRows = JSON.parse(JSON.stringify(this.moduleRows))
      const tableTitles = JSON.parse(JSON.stringify(this.tableTitles))

      moduleRows = await this.fetchAllDataToDownload()

      const dataSource = moduleRows.map(item => {
        delete item['__hash']
        delete item['__can_edit']

        Object.keys(item).forEach(column => {
          if (item[column] === null) {
            item[column] = ''
          }

          item[column] = `"${item[column]}"`

        })
        return item
      })
      const header = tableTitles.map(item => {
        return `"${item.title}"`
      })

      jsontoexcel.getXlsx(dataSource, header, this.moduleInfo.moduleName)
    },
    handleSearchOld(searching) {

      if (searching !== '') {
        const filteredRows = []

        this.fullModuleRows.forEach(item => {
          let itemAlreadyPushed = false
          Object.keys(item).forEach(itemKey => {
            if (typeof item[itemKey] === 'string' && item[itemKey].toLowerCase().includes(searching.toLowerCase())) {
              if (!itemAlreadyPushed) {
                filteredRows.push(item)
                itemAlreadyPushed = true
              }
            }
          })
        })

        this.moduleRows = filteredRows
      } else {
        this.moduleRows = this.fullModuleRows
      }

      // console.log(this.moduleRows)
      // console.log(this.fullModuleRows)
    },
    async handleSearch(searchKey) {
      this.searchKey = searchKey
      this.applyFilters()
      // this.$vs.loading({type: 'default'})
      // await this.listModuleRows(this.pagination.per_page, this.pagination.currentPage)
      // this.$vs.loading.close()
    },
    async handleChangePage(page) {
      // this.$vs.loading({type: 'default'})
      // this.moduleRows = []
      this.pagination['currentPage'] = page
      // await this.listModuleRows(this.pagination.per_page, page)
      // this.$vs.loading.close()
      this.applyFilters()
    },
    async handleSort(key, active) {
      // this.$vs.loading({type: 'default'})
      this.orderData.field = this.fieldHashObject[key]
      if (active !== null) {
        this.orderData.type = active.toUpperCase()
      }
      this.applyFilters()
      // await  this.listModuleRows(this.maxItems, this.pagination['currentPage'])
      // this.$vs.loading.close()
    },
    checkIfStringIsDateTime(string) {

      try {
        if ((string.split('-').length - 1) == 2 && (string.split(':').length - 1) == 2 && (string.split(' ').length - 1) == 1) {
          return true
        } else {
          return false
        }
      } catch (e) {
        return false
      }
    },
    checkIfStringIsDate(string) {
      try {
        if ((string.split('-').length - 1) == 2 && (string.length === 10)) {
          return true
        } else {
          return false
        }
      } catch (e) {
        return false
      }
    },
    confirmDeleteRecord(rowHash) {
      this.rowHashToDelete = rowHash
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirmar Exclusão',
        text: 'Você tem certeza que deseja excluir esse registro ?',
        accept: this.deleteRecord,
        acceptText: 'Excluir'
      })
    },
    exportCSV() {

    },
    async deleteRecord() {

      this.$vs.loading({ type: 'default' })

      const requestBody = {
        application_token: this.$store.state.auth.app_token,
        session_token: this.$store.state.auth.token,
        module_token: this.$route.params.moduleHash,
        row_hash: this.rowHashToDelete
      }

      // await fetch(`${this.$store.state.auth.api_url}`, {
      //   method: 'POST', headers: {"Content-Type": "application/json"},
      //   body: JSON.stringify({
      //     command: 'delete_module_row',
      //     parameters: requestBody
      //   })
      // })
      await performFetch(this.$store.state.auth.api_url, {
        command: 'delete_module_row',
        parameters: requestBody
      })
        .then(async (response) => {
          if (response.status === 200) {
            response.json().then(async (response) => {

              this.$vs.loading.close()

              this.$vs.notify({
                title: 'Operação Realizada!',
                text: response.message,
                iconPack: 'feather',
                icon: 'icon-check-circle',
                color: 'success'
              })

              this.$vs.loading({ type: 'default' })

              this.pagination['currentPage'] = 1
              this.pagination['pages'] = 1
              this.pagesToShow = 1
              this.paginationModel = 1
              await this.listModuleRows(this.maxItems, 1)
              this.$vs.loading.close()
            })
          } else if (response.status == 401) {
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          } else if (response.status == 403) {
            this.$vs.loading.close()
            this.$vs.notify({
              title: 'Atenção!',
              text: 'Você não tem permissão para deletar registros neste módulo!',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning'
            })
          } else {
            this.$vs.loading.close()
            this.$vs.notify({
              title: 'Operação não realizada!',
              text: 'Ocorreu um erro ao deletar o registro',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
          }
        })
        .catch((e) => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Operação não realizada!',
            text: e.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
          throw new Error(e.message)
        })

      this.rowHashToDelete = ''
    },
    async listModuleRows(per_page, page, searchKey = null, filter = null) {

      this.moduleRows = []

      let orderData = null

      if (this.orderData.field !== null && this.orderData.type !== null) {
        orderData = JSON.parse(JSON.stringify(this.orderData))
      }

      const parametersObject = {
        application_token: this.$store.state.auth.app_token,
        session_token: this.$store.state.auth.token,
        module_token: this.$route.params.moduleHash,
        list_hash: this.$route.params.listHash,
        per_page: per_page,
        page: page,
        order: orderData,
        give_options: false
      }

      if (this.searchKey !== null) {
        parametersObject['search'] = this.searchKey
      }

      if (filter !== null) {
        parametersObject['filter'] = filter
      }

      // await fetch(`${this.$store.state.auth.api_url}`, {
      //   method: 'POST', headers: {"Content-Type": "application/json"},
      //   body: JSON.stringify({
      //     command: 'list_module_rows',
      //     parameters: parametersObject
      //   })
      // })
      await performFetch(this.$store.state.auth.api_url, {
        command: 'list_module_rows',
        parameters: parametersObject
      })
        .then((response) => {
          if (response.status === 200) {
            response.json().then((responseData) => {

              console.log(responseData.payload)

              this.maxItems = responseData.detail.lines_per_page

              if (responseData.payload.length > 0) {

                for (let i = 0; i < Object.keys(responseData.payload[0]['items']).length; i++) {
                  this.fieldHashObject[Object.keys(responseData.payload[0]['items'])[i]] = responseData.payload[0]['items'][Object.keys(responseData.payload[0]['items'])[i]]['hash']
                }

              }

              this.moduleRows = []

              this.pagination['currentPage'] = responseData.pagination.current_page
              this.pagination['pages'] = responseData.pagination.pages
              this.pagination['per_page'] = this.maxItems
              this.pagination['total_records'] = responseData.pagination.total_records

              if (this.pagination['pages'] <= 10) {

                if (this.pagination['pages'] % 2 === 0) {
                  this.pagesToShow = this.pagination['pages'] - 1
                } else {
                  this.pagesToShow = this.pagination['pages']
                }
              } else {
                this.pagesToShow = 10
              }

              try {
                this.permissions['canCreate'] = responseData.permissions.can_create
                this.permissions['canEdit'] = responseData.permissions.can_edit
                this.permissions['canDelete'] = responseData.permissions.can_delete
                this.permissions['canView'] = responseData.permissions.can_view
                this.permissions['canList'] = responseData.permissions.can_list
                this.permissions['canExport'] = responseData.permissions.can_export
              } catch (e) {
                console.log('error on assign permissions')
              }

              // this.moduleRows = new Array(this.pagination['total_records'])

              document.title = `${document.title.split(' | ')[0]} | ${this.$displayLabel(responseData.detail, 'module_name')}`

              if (responseData.payload.length > 0) {

                responseData.payload.sort((a, b) => a.index - b.index)

                responseData.payload.forEach((item, key) => {

                  let formattedItems = []

                  if (!(item.items && Object.keys(item.items).length === 0 && item.items.constructor === Object)) {

                    for (let i = 0; i < Object.entries(item.items).length; i++) {
                      let itemObject = Object.entries(item.items)[i]

                      const objectKey = itemObject[0]
                      let objectValue = itemObject[1]
                      let objectIndex = objectValue.index

                      if (typeof objectValue === 'object' && objectValue !== null) {

                        if (objectValue.secret === true) {
                          if (this.tableTitles.find(x => x.name === objectValue.name) === undefined) {
                            this.tableTitles.push({
                              title: objectValue.title,
                              title_en: objectValue.title_en,
                              name: objectValue.name,
                              index: objectValue.index
                            })
                          }

                          objectValue = '*****'
                        } else {
                          if (this.tableTitles.find(x => x.name === objectValue.name) === undefined) {
                            this.tableTitles.push({
                              title: objectValue.title,
                              title_en: objectValue.title_en,
                              name: objectValue.name,
                              index: objectValue.index
                            })
                          }

                          switch (objectValue.type_id) {

                            case 35:
                              if (Array.isArray(objectValue.payload)) {
                                let formattedArray = [];
                                let index = 0;
                                for (const date of objectValue.payload) {
                                  if (index === 3) {
                                    break;
                                  }
                                  const year = date.split('-')[0]
                                  const month = date.split('-')[1]
                                  const day = date.split('-')[2]
                                  formattedArray.push(`${day}/${month}/${year}`)
                                  index += 1;
                                }
                                objectValue = formattedArray.join(", ") + `${objectValue.payload.length > 3 ? "..." : ""}`
                              } else {
                                objectValue = null;
                              }

                              break

                            case 16:
                            case 18:
                            case 20:
                              const type_id = objectValue.type_id
                              const showProgressBar = objectValue.show_progress_bar

                              let config = null

                              if (objectValue.type_id === 16 || objectValue.type_id === 20) {
                                config = { minimumFractionDigits: objectValue.decimals, maximumFractionDigits: objectValue.decimals }
                              } else {
                                config = { style: 'currency', currency: 'BRL', minimumFractionDigits: objectValue.decimals, maximumFractionDigits: objectValue.decimals }
                              }

                              const value = parseFloat(objectValue.payload)

                              if (!isNaN(value)) {
                                objectValue = parseFloat(objectValue.payload).toLocaleString('pt-BR', config)

                                if (type_id === 16) {
                                  if (showProgressBar) {
                                    objectValue = objectValue + '%%'
                                  } else {
                                    objectValue = objectValue + '%'
                                  }
                                }
                              } else {
                                objectValue = null
                              }

                              break

                            case 32:
                            case 33:

                              let objectString = ''

                              let itemsAmount = 0

                              for (let item of objectValue.payload_text) {

                                if (itemsAmount === 5) {
                                  break
                                }

                                objectString += item + ', '

                                itemsAmount += 1
                              }

                              if (objectString !== '') {
                                objectValue = objectString.substring(0, objectString.length - 2) + ' ...'
                              } else {
                                objectValue = ''
                              }

                              break

                            case 19:
                              if (objectValue.payload && objectValue.payload.length > 50) {
                                objectValue = objectValue.payload.substr(0, 50) + '...'
                              } else {
                                objectValue = objectValue.payload
                              }

                              break

                            case this.$FIELD_TYPES.PUSH_TAGS_LIST:
                              if (objectValue.type_id === this.$FIELD_TYPES.PUSH_TAGS_LIST) {
                                if (objectValue.payload) {
                                  objectValue = objectValue.payload.reduce((acc, currentValue) => {
                                    if (acc === '') {
                                      return `${currentValue}`
                                    } else {
                                      return `${acc},  ${currentValue}`
                                    }
                                  })
                                }
                              }

                              break

                            case 12:
                              if (objectValue.payload !== null) {
                                const isDate = this.checkIfStringIsDate(objectValue.payload)

                                if (isDate) {

                                  objectValue = `${objectValue.payload.split('-')[2]}/${objectValue.payload.split('-')[1]}/${objectValue.payload.split('-')[0]}`
                                }
                              } else {
                                objectValue = null
                              }

                              break

                            case 13:
                              if (objectValue.payload !== null) {
                                const isDateTime = this.checkIfStringIsDateTime(objectValue.payload)

                                if (isDateTime) {

                                  const date = objectValue.payload.split(' ')[0].trim()
                                  const time = objectValue.payload.split(' ')[1].trim()

                                  objectValue = `${date.split('-')[2]}/${date.split('-')[1]}/${date.split('-')[0]} ${time}`

                                }
                              } else {
                                objectValue = null
                              }

                              break


                            default:

                              if (objectValue.mask) {

                                if (objectValue.type_id === 3) {

                                  if (objectValue.payload !== null && objectValue.payload.length === 10) {
                                    const formatter = new StringMask('(##) ####-####')
                                    const result = formatter.apply(objectValue.payload)

                                    objectValue = result
                                  } else if (objectValue.payload !== null && objectValue.payload.length === 11) {
                                    const formatter = new StringMask('(##) #####-####')
                                    const result = formatter.apply(objectValue.payload)

                                    objectValue = result
                                  } else {
                                    const formatter = new StringMask(objectValue.mask)
                                    const result = formatter.apply(objectValue.payload)

                                    objectValue = result
                                  }
                                } else {
                                  const formatter = new StringMask(objectValue.mask)
                                  const result = formatter.apply(objectValue.payload)

                                  objectValue = result
                                }

                              } else {
                                objectValue = objectValue.payload
                              }

                              break

                          }
                        }

                        itemObject[1] = objectValue
                      }

                      const fieldObject = {
                        key: itemObject[0],
                        value: itemObject[1],
                        index: objectIndex
                      }

                      formattedItems.push(fieldObject)
                    }

                    this.tableTitles = this.tableTitles.sort((a, b) => a.index - b.index)

                    formattedItems = formattedItems.sort((a, b) => a.index - b.index)

                    formattedItems.push({ key: '__hash', value: item.identification })
                    formattedItems.push({ key: '__index', value: item.index })
                    formattedItems.push({ key: '__can_edit', value: item.can_edit !== undefined ? item.can_edit : true })

                    const moduleRow = {}

                    // formattedItems.forEach((item) => {
                    //   moduleRow[item['key']] = item['value']
                    // })

                    for (let i = 0; i < formattedItems.length; i++) {
                      moduleRow[formattedItems[i]['key']] = formattedItems[i]['value']
                    }

                    this.moduleRows[key] = moduleRow
                  } else {
                    this.moduleRows = []
                  }
                })

                if (responseData.payload.length < responseData.detail.lines_per_page) {

                  this.moduleRows = this.moduleRows.filter(el => el != null)
                }
              }

              this.moduleRows = JSON.parse(JSON.stringify(this.moduleRows.sort((a, b) => a.__index - b.__index)))

              this.fullModuleRows = this.moduleRows
              this.tableKey = Math.random()
            })
              .catch(e => {
                this.$vs.loading.close()
                this.$vs.notify({
                  title: 'Atenção!',
                  text: e.message,
                  iconPack: 'feather',
                  icon: 'icon-alert-circle',
                  color: 'danger'
                })
                throw new Error(e.message)
              })
          } else if (response.status === 400) {
            // this.$router.push(`/modules/view/${this.$route.params.moduleHash}`)
            this.$vs.loading.close()
            this.$vs.notify({
              title: 'Operação não realizada!',
              text: 'Ocorreu um erro ao listar os registros do módulo',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
          } else if (response.status === 403) {
            this.$vs.loading.close()
            this.showEmptyDataMessage = true
          } else if (response.status === 401) {
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          } else {
            this.$vs.loading.close()
            this.$vs.notify({
              title: 'Operação não realizada!',
              text: 'Ocorreu um erro ao listar os registros do módulo',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
          }
        })
        .catch((e) => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Atenção!',
            text: e.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
          throw new Error(e.message)
        })
    },
    async getModuleParameters() {

      return new Promise(async (resolve, reject) => {

        // await fetch(`${this.$store.state.auth.api_url}`, {
        //   method: 'POST', headers: {"Content-Type": "application/json"},
        //   body: JSON.stringify({
        //     command: 'list_module_rows_parameters',
        //     parameters: {
        //       application_token: this.$store.state.auth.app_token,
        //       session_token: this.$store.state.auth.token,
        //       module_token: this.$route.params.moduleHash
        //     }
        //   })
        // })
        await performFetch(this.$store.state.auth.api_url, {
          command: 'list_module_rows_parameters',
          parameters: {
            application_token: this.$store.state.auth.app_token,
            session_token: this.$store.state.auth.token,
            module_token: this.$route.params.moduleHash
          }
        })
          .then((response) => {
            if (response.status === 200) {
              response.json().then((responseData) => {

                const displayModuleName = this.$displayLabel(responseData.detail, 'module_name')
                document.title = `${document.title.split(' | ')[0]} | ${displayModuleName}`

                this.moduleInfo['moduleName'] = responseData.detail.module_name
                this.moduleInfo['moduleNameEn'] = responseData.detail.module_name_en
                this.$store.commit('auth/SET_CURRENT_MODULE_NAME', { module_name: responseData.detail.module_name, module_name_en: responseData.detail.module_name_en })

                this.maxItems = responseData.detail.lines_per_page

                resolve(true)
              })
                .catch(e => {
                  this.$vs.loading.close()
                  this.$vs.notify({
                    title: 'Atenção!',
                    text: e.message,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                  })
                  throw new Error(e.message)
                })
            } else if (response.status === 400) {
              this.$router.push(`/modules/view/${this.$route.params.moduleHash}`)
            } else if (response.status === 403) {
              this.$vs.loading.close()
              this.showEmptyDataMessage = true
            } else if (response.status === 401) {
              setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
              this.$store.dispatch('auth/signOut')
            } else {
              this.$vs.loading.close()
              this.$vs.notify({
                title: 'Operação não realizada!',
                text: 'Ocorreu um erro ao listar os registros do módulo',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
              })
            }
          })
          .catch((e) => {
            this.$vs.loading.close()
            this.$vs.notify({
              title: 'Atenção!',
              text: e.message,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
            throw new Error(e.message)
          })
      })
    },
    async applyFilters() {

      const filter = this.buildFilterFromForm()

      this.$vs.loading({ type: 'default' })
      await this.listModuleRows(this.maxItems, this.pagination['currentPage'], null, filter)
      this.$vs.loading.close()
    },
    async clearFilters() {
      for (const fieldModel of Object.entries(this.queryFieldsModel)) {
        const fieldHash = fieldModel[0]
        const fieldValue = fieldModel[1]

        this.queryFieldsModel[fieldHash] = null
      }

      this.$vs.loading({ type: 'default' })
      await this.listModuleRows(this.maxItems, this.pagination['currentPage'], null, null)
      this.$vs.loading.close()
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('auth/SET_CURRENT_MODULE_NAME', null)
    clearInterval(this.getDataInterval)
    next()
  },
  async mounted() {

    document.querySelector('.vx-card').style.backgroundColor = '#fff'

    let me = this

    document.addEventListener("keydown", function (event) {
      var KeyID = event.keyCode;
      switch (KeyID) {
        case 8:
        case 46:
          if (document.activeElement.tagName === 'INPUT' && document.activeElement.hasAttribute("placeholder") && document.activeElement.hasAttribute('autocomplete')) {
            if (document.activeElement.getAttribute("autocomplete") === "off") {
              if (document.activeElement.parentElement.parentElement.parentElement.parentElement.parentElement.getAttribute('type') === 'from') {
                me.datesModel[document.activeElement.parentElement.parentElement.parentElement.parentElement.parentElement.getAttribute('data-field-hash')]['from'] = null
              } else {
                me.datesModel[document.activeElement.parentElement.parentElement.parentElement.parentElement.parentElement.getAttribute('data-field-hash')]['to'] = null
              }
            }
          }
          break;
        default:
          break;
      }
    });
  },
  async created() {
    this.$vs.loading({ type: 'default' })
    await this.getSearchFields()
    await this.getModuleParameters()
    await this.getModuleActions()
    this.moduleRows = []
    this.pagination['currentPage'] = 1
    this.$vs.loading.close()
  }
}
</script>
<style scoped>
.con-vs-chip {
  min-width: 50px !important;
  font-size: 0.9rem !important;
}
</style>
